import React from "react"

import { ChatBotFlowBlockRule } from "@/protocols/chatBot"
import BlockBodySection from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySection"
import BlockBodySectionRequiredCondition, { ContinueConditionIcon } from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySectionRequiredCondition"
import BlockBodySectionHandle from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySectionHandle"

import { getConditionByValidationSlug } from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/utils/chatBotFlowBlockRule"

type NoFieldFilledConditionSectionProps = {
	nextChatBotFlowBlockRules: ChatBotFlowBlockRule[]
	text: string
}

const NoFieldFilledConditionSection: React.FC<NoFieldFilledConditionSectionProps> = (props) => {
	const {
		nextChatBotFlowBlockRules,
		text
	} = props

	const noFieldFilledCondition = getConditionByValidationSlug("no-field-filled", nextChatBotFlowBlockRules)

	if (!noFieldFilledCondition) {
		return null
	}

	return (
		<BlockBodySection>
			<BlockBodySectionHandle
				chatBotFlowBlockRule={noFieldFilledCondition.rule}
			>
				<BlockBodySectionRequiredCondition
					text={text}
					icon={<ContinueConditionIcon />}
				/>
			</BlockBodySectionHandle>
		</BlockBodySection>
	)
}

export default NoFieldFilledConditionSection
